import type { CanvasObject, CanvasObjectType } from "@refinement-canvas/domain";

// 「外接矩形を片軸だけ伸縮しても見た目のアスペクト比が変わらない」オブジェクト種別。
// - image: objectFit:contain で枠内に縦横比を保って収まる（片軸を伸ばしても余白が増えるだけ）
// - video: image と同じ contain 表示
// - stamp: 絵文字グリフを min(w,h) 基準で中央に描画する（片軸を伸ばしても余白が増えるだけ）
// これらは片軸リサイズに意味が無いため、選択時は四隅(斜め)ハンドルのみを表示し、
// 四隅ドラッグでは常にアスペクト比を維持する。
const ASPECT_LOCKED_OBJECT_TYPES: ReadonlySet<CanvasObjectType> = new Set([
  "image",
  "video",
  "stamp",
]);

/**
 * 指定オブジェクトがアスペクト比固定（四隅のみリサイズ）対象かどうかを返す。
 */
export function keepsAspectRatio(object: CanvasObject): boolean {
  return ASPECT_LOCKED_OBJECT_TYPES.has(object.type);
}
